import { render } from "./ClienteHistoricoView.vue?vue&type=template&id=657f334e"
import script from "./ClienteHistoricoView.vue?vue&type=script&lang=js"
export * from "./ClienteHistoricoView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__